export const getCookie = (name) => {
  const cookiesMap = document.cookie.split(';').map((cookie) => cookie.trim().split('='))

  const cookieToFind = cookiesMap.find((cookie) => cookie[0] === name)

  return cookieToFind ? cookieToFind[0] : null
}

export const setCookie = (name, value = '', isNeverExpire = false) => {
  if (getCookie(name) === null) {
    let cookieValue = `${name}=${value}; path=/; secure;`
    if (isNeverExpire) {
      const date = new Date()
      date.setFullYear(date.getFullYear() + 10)
      cookieValue += ` expires=${date.toUTCString()};`
    }

    document.cookie = cookieValue
  }

  return null
}
